import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { toast } from '@treasuryspring/spring-ui';

import { PdfResponse, PdfResponseSchema } from '@/types';
import { fetchJSONSameOrigin, getResponseJSON } from '@/utils/api';
import { downloadBase64Data, getDateString } from '@/utils/helper-functions';

interface RequestPdfParams {
  clientName: string;
  clientEmail: string;
  token: string;
}

async function requestPdf({
  clientName,
  clientEmail,
  token,
}: RequestPdfParams): Promise<PdfResponse> {
  const requestData = {
    clientName,
    clientEmail,
    token,
  };
  const res = await fetchJSONSameOrigin('/request-pdf', requestData, 'POST');
  const data = await getResponseJSON(res);
  const pdfResponse = PdfResponseSchema.parse(data);
  await downloadBase64Data(
    `data:application/pdf;base64,${pdfResponse.pdf_base64}`,
    `TreasurySpring_Rate_Card_${getDateString('_')}.pdf`
  );
  return pdfResponse;
}

export const useRequestPdfMutation = (
  options?: Partial<UseMutationOptions<PdfResponse, Error, RequestPdfParams>>
) => {
  return useMutation<PdfResponse, Error, RequestPdfParams>({
    ...options,
    mutationKey: ['requestPdf'],
    mutationFn: requestPdf,
    onSuccess: (...args) => {
      toast.success('PDF downloaded');
      options?.onSuccess?.(...args);
    },
    onError: (error, ...args) => {
      toast.error(error.message);
      options?.onError?.(error, ...args);
    },
  });
};
